import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { FaCogs, FaRobot } from "react-icons/fa";
import img1 from "../../../assets/img/Industries/Aerospace/bdf731b3-9cc8-4364-b9c6-22a5e30c0d3d.jpg";

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Predictive Maintenance and Asset Management
            </h1>
            <p className="text-lg text-gray-600">
              Optimize asset performance and minimize downtime with AI-powered
              predictive maintenance solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaRobot className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  AI-Powered Maintenance
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Predict equipment failures and optimize maintenance schedules to
                reduce downtime and extend asset lifecycles.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaCogs className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Fleet Monitoring
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Use real-time data analytics to monitor fleet health and
                performance, ensuring operational reliability.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoCheckmarkCircleOutline className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Spare Parts Optimization
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Implement data-driven inventory management to ensure timely
                availability of critical components.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
